
import Vue from 'vue'

Vue.filter('filterPhone',(num)=>{
    num=String(num).replace(String(num).substring(3,7), "****")
    return num
})
